import { env } from '@/env';
import type { RuntimeFlagValue, RuntimeModeSnapshot } from '@/lib/runtime-mode-resolver';
import { resolveRuntimeModeSnapshot as resolveRuntimeModeSnapshotInternal } from '@/lib/runtime-mode-resolver';
import { readSystemEnvString } from '@/lib/utils/env';

export type { RuntimeModeEnvLike, RuntimeModeSnapshot, RuntimeModeSystemEnvLike } from '@/lib/runtime-mode-resolver';
export { resolveRuntimeModeSnapshot } from '@/lib/runtime-mode-resolver';

function safeReadServerFlag(read: () => unknown): RuntimeFlagValue {
  try {
    const value = read();
    if (typeof value === 'boolean' || typeof value === 'number' || typeof value === 'string' || value === null) {
      return value;
    }
    return;
  } catch {
    return;
  }
}

export function getRuntimeModeSnapshot(): RuntimeModeSnapshot {
  return resolveRuntimeModeSnapshotInternal(
    {
      NEXT_PUBLIC_API_MOCK: env.NEXT_PUBLIC_API_MOCK,
      NEXT_PUBLIC_MSW: env.NEXT_PUBLIC_MSW,
      NEXT_PUBLIC_PLAYWRIGHT_TEST: env.NEXT_PUBLIC_PLAYWRIGHT_TEST,
      PLAYWRIGHT_TEST: safeReadServerFlag(() => env.PLAYWRIGHT_TEST),
      PLAYWRIGHT_RUNTIME: safeReadServerFlag(() => env.PLAYWRIGHT_RUNTIME),
      PLAYWRIGHT_TEST_RUNTIME: safeReadServerFlag(() => env.PLAYWRIGHT_TEST_RUNTIME),
      PLAYWRIGHT_MOCK_AUTH: safeReadServerFlag(() => env.PLAYWRIGHT_MOCK_AUTH),
      PLAYWRIGHT_AUTH_DEBUG: safeReadServerFlag(() => env.PLAYWRIGHT_AUTH_DEBUG),
    },
    {
      NEXT_PHASE: readSystemEnvString('NEXT_PHASE'),
      CI: readSystemEnvString('CI'),
      GITHUB_ACTIONS: readSystemEnvString('GITHUB_ACTIONS'),
    }
  );
}

export function isBuildPhase(): boolean {
  return getRuntimeModeSnapshot().isBuildPhase;
}

export function isCiRuntime(): boolean {
  return getRuntimeModeSnapshot().isCiRuntime;
}

export function isApiMockRuntime(): boolean {
  return getRuntimeModeSnapshot().isApiMockRuntime;
}

export function isPlaywrightRuntime(): boolean {
  return getRuntimeModeSnapshot().isPlaywrightRuntime;
}

export function isAutomationRuntime(): boolean {
  return getRuntimeModeSnapshot().isAutomationRuntime;
}

export function isMockAuthRuntime(): boolean {
  return getRuntimeModeSnapshot().isMockAuthRuntime;
}

export function isPlaywrightAuthDebugEnabled(): boolean {
  return getRuntimeModeSnapshot().isPlaywrightAuthDebugEnabled;
}
